import React, { ReactNode, useEffect, useState } from "react";
import { AppBox, AppButton, AppFlyMenu, AppPaper, AppTitle } from ".";
import { IFlyMenuOptions } from "./ui-components/Fly-menu";
import AppBorderBox from "./BorderBox";
import IconChevronUp from "./icons/chevron-up";
import IconChevronBottom from "./icons/chevron-bottom";

interface GroupComponentProps {
  title: string;
  withButton?: boolean;
  withSecondaryButton?: boolean;
  primaryButtonTitle?: string;
  secondaryButtonTitle?: string;
  withoutFlyMenu?: boolean;
  flyMenuOptions?: IFlyMenuOptions[];
  children: ReactNode;
  onFlyMenuOptionSelect?: (value: string) => void;
  onButtonClick?: () => void;
  onSecondaryButtonClick?: () => void;
  onToggleShowHide?: (isActive: boolean) => void;
}

const GroupComponent = ({
  title,
  flyMenuOptions,
  children,
  withoutFlyMenu = false,
  withButton: withAddButton,
  withSecondaryButton,
  primaryButtonTitle = "Add",
  secondaryButtonTitle = "",
  onFlyMenuOptionSelect,
  onButtonClick,
  onSecondaryButtonClick,
  onToggleShowHide,
}: GroupComponentProps) => {
  const [isActive, setIsActive] = useState(true);
  const handleOptionSelect = (value: string) => {
    if (onFlyMenuOptionSelect) {
      onFlyMenuOptionSelect(value);
    }
  };

  useEffect(() => {
    if (onToggleShowHide) {
      onToggleShowHide(isActive);
    }
  }, [isActive]);

  return (
    <AppPaper padding="none" shadow="xs">
      <AppBox flexDirection="column" gap="sm">
        <AppBorderBox border={isActive ? ["Bottom"] : []}>
          <AppBox px="sm" pt="sm" alignItems="center" justifyContent="space-between" pb="xs">
            <AppTitle as="h6" withWhiteSpace>
              {title}
            </AppTitle>
            <AppBox alignItems="center" gap="xs">
              {withSecondaryButton && (
                <AppButton
                  variant="light"
                  label={secondaryButtonTitle}
                  size="sm"
                  onClick={() => {
                    if (onSecondaryButtonClick) {
                      onSecondaryButtonClick();
                    }
                  }}
                />
              )}
              {withAddButton && (
                <AppButton
                  label={primaryButtonTitle}
                  size="sm"
                  onClick={() => {
                    if (onButtonClick) {
                      onButtonClick();
                    }
                  }}
                />
              )}
              {flyMenuOptions && !withoutFlyMenu && (
                <AppBox alignItems="center" gap="2xs">
                  <AppFlyMenu options={flyMenuOptions} onSelect={handleOptionSelect} />
                </AppBox>
              )}
              <span
                style={{ userSelect: "none", cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsActive(!isActive);
                }}
              >
                {isActive ? <IconChevronUp /> : <IconChevronBottom />}
              </span>
            </AppBox>
          </AppBox>
        </AppBorderBox>
        <AppBox style={{ display: !isActive ? "none" : "" }}>{children}</AppBox>
      </AppBox>
    </AppPaper>
  );
};

export default GroupComponent;
